import * as Api from './Api';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import StackTrace from 'stacktrace-js';

export const THROTTLE_INTERVAL = 1000;

// views
export const VIEW_PR_TAB = 'pr.tab.view';

// customer onboarding
export const ONBOARDING_INSTALL_CLICK = 'onboarding.install.click';
export const ONBOARDING_OAUTH_CLICK = 'onboarding.oauth.click';
export const ONBOARDING_PROVIDER_INSTALL_ERROR =
  'onboarding.provider_install.error';
export const ONBOARDING_SELECT_PROVIDER_PAGE =
  'customer.onboarding.select_provider.load';
export const ONBOARDING_CONNECTING_PAGE = 'customer.onboarding.connecting.load';

// h1 security fix review
export const STEPPER_ONE_START = 'h1sfr.stepper.one.start';
export const REVIEW_TITLE_SEARCH_CHANGE = 'h1sfr.search_for_review';
export const STEPPER_ONE_NEXT = 'h1sfr.stepper.one.next';
export const EDIT_SELECTED_REVIEW = 'h1sfr.stepper.edit_selected_review';
export const STEPPER_TWO_NEXT = 'h1sfr.stepper.two.next';
export const STEPPER_SUBMIT_FOR_REVIEW_CLICK =
  'h1sfr.stepper.submit_for_review.click';
export const STEPPER_SELECT_FIX_CLICK = 'h1sfr.stepper.select_fix.click';

// login/logout
export const USER_LOGIN_EMAIL_CLICK = 'user_login.email.click';
export const USER_LOGIN_OAUTH_GITHUB_CLICK = 'user_login.oauth.github.click';
export const USER_LOGIN_OAUTH_GITLAB_CLICK = 'user_login.oauth.gitlab.click';
export const USER_LOGIN_OAUTH_AZURE_DEVOPS_CLICK =
  'user_login.oauth.azuredevops.click';
export const USER_LOGIN_OAUTH_BITBUCKET_CLICK =
  'user_login.oauth.bitbucket.click';
export const USER_LOGIN_OAUTH_HACKERONE_CLICK =
  'user_login.oauth.hackerone.click';
export const USER_LOGOUT_CLICK = 'user_logout.click';

// header bar
export const HOME_CLICK = 'home.click';

// new dashboard
export const DASHBOARD_SCROLL = 'dashboard.scroll';
export const DASHBOARD_COMPLETED_CR_GO_TO_METRICS =
  'dashboard.project_stat.completed_cr.metrics_link.click';
export const DASHBOARD_COMMENTS_PER_CR_GO_TO_METRICS =
  'dashboard.project_stat.comments_per_cr.metrics_link.click';
export const DASHBOARD_CR_SIZE_GO_TO_METRICS =
  'dashboard.project_stat.cr_size.metrics_link.click';
export const DASHBOARD_LIFECYCLE_STAT_GO_TO_METRICS =
  'dashboard.project_stat.lifecycle.metrics_link.click';
export const DASHBOARD_CONTRIBUTION_VOLUME_GO_TO_METRICS =
  'dashboard.contribution_volume.metrics_link.click';
export const DASHBOARD_REVIEW_LIFECYCLE_GO_TO_METRICS =
  'dashboard.review_lifecycle.metrics_link.click';
export const DASHBOARD_BIGGEST_CHANGES_GO_TO_METRICS =
  'dashboard.biggest_changes.metrics_link.click';
export const DASHBOARD_AUTHOR_HIGHLIGHTS_GO_TO_METRICS =
  'dashboard.highlights.author.metrics_link.click';
export const DASHBOARD_PROJECT_HIGHLIGHTS_GO_TO_METRICS =
  'dashboard.highlights.project.metrics_link.click';
export const DASHBOARD_REVIEWER_HIGHLIGHTS_GO_TO_METRICS =
  'dashboard.highlights.reviewer.metrics_link.click';
export const DASHBOARD_INDUSTRY_BENCHMARKS_CLICK =
  'dashboard.industry_benchmark_standings.click';
export const DASHBOARD_ONBOARDING_MEMBERSHIP_CLICK =
  'dashboard.onboarding.membership.click';
export const DASHBOARD_ONBOARDING_MEETING_CLICK =
  'dashboard.onboarding.meeting.click';
export const DASHBOARD_ONBOARDING_DOCUMENTATION_CLICK =
  'dashboard.onboarding.documentation.click';
export const DASHBOARD_ORGANIZATION_BREAKDOWN_VIEW_CURRENT_PERIOD_CLICK =
  'dashboard.organization_breakdown.click';
export const DASHBOARD_PULLREQUEST_CONTRIBUTION_LINK_CLICK =
  'dashboard.pullrequest_contribution.review.click';
export const DASHBOARD_INVALID_METRIC_SEEN =
  'dashboard.api.top_five_metrics.invalid_metric';

// comment history
export const COMMENT_HISTORY_LOAD = 'comment_history.load';
export const COMMENT_HISTORY_SCROLL = 'comment_history.scroll';
export const COMMENT_HISTORY_FILTER_COMMENT_TYPE =
  'comment_history.filter.comment_type';
export const COMMENT_HISTORY_FILTER_SEVERITY =
  'comment_history.filter.severity';
export const COMMENT_HISTORY_FILTER_CATEGORY =
  'comment_history.filter.category';
export const COMMENT_HISTORY_FILTER_DATE_RANGE =
  'comment_history.filter.date_range';
export const COMMENT_HISTORY_FILTER_SORT = 'comment_history.filter.sort_by';
export const COMMENT_HISTORY_FILTER_RESET = 'comment_history.filter.reset';
export const COMMENT_HISTORY_FILTER_PAGINATE =
  'comment_history.filter.paginate';

// Reviewer Application
export const REVIEWER_APPLICATION_LINKS = 'reviewer.application.links.load';
export const REVIEWER_APPLICATION_ADDITIONAL_INFO =
  'reviewer.application.additional_info.load';
export const REVIEWER_APPLICATION_SKILLS = 'reviewer.application.skills.load';
export const REVIEWER_APPLICATION_CONFIDENCE =
  'reviewer.application.confidence.load';
export const REVIEWER_APPLICATION_PENDING = 'reviewer.application.pending.load';
export const REVIEWER_ONBOARDING_TWO_FACTOR =
  'reviewer.onboarding.two_factor.load';
export const REVIEWER_ONBOARDING_SLACK = 'reviewer.onboarding.slack.load';
export const REVIEWER_ONBOARDING_SETTINGS = 'reviewer.onboarding.settings.load';

// account selector
export const ACCOUNT_SELECTOR_CLICK = 'account_selector.click';

// organization selector
export const ORG_SELECTOR_CLICK = 'org_selector.click';
export const ORG_SELECTOR_ADD_ORGS_CLICK = 'org_selector.add_orgs.click';
export const ORG_SELECTOR_SELECTION_CLICK = 'org_selector.selection.click';

// project selector
export const PROJECT_SELECTOR_CLICK = 'project_selector.click';
export const PROJECT_SELECTOR_ADD_PROJECTS_CLICK =
  'project_selector.add_projects.click';
export const PROJECT_SELECTOR_SELECTION_CLICK =
  'project_selector.selection.click';

// sidebar global
export const SIDEBAR_COLLAPSE_CLICK = 'sidebar.collapse.click';

// org sidebar navigation
export const ORG_NAV_HOME_CLICK = 'org.nav.home.click';
export const ORG_NAV_DASHBOARD_CLICK = 'org.nav.dashboard.click';
export const ORG_NAV_BENCHMARKS_CLICK = 'org.nav.benchmarks.click';
export const ORG_NAV_METRICS_CLICK = 'org.nav.metrics.click';
export const ORG_NAV_SETTINGS_CLICK = 'org.nav.settings.click';
export const ORG_NAV_SETTINGS_BILLING_CLICK = 'org.nav.settings.billing.click';
export const ORG_NAV_PROJECT_SETTINGS_CLICK = 'org.nav.project_settings.click';
export const ORG_NAV_PROXY_SETTINGS_CLICK = 'org.nav.proxy_settings.click';
export const ORG_NAV_MEMBERSHIP_CLICK = 'org.nav.membership.click';
export const ORG_NAV_NEW_REVIEW_CLICK = 'org.nav.new_review.click';
export const ORG_NAV_PROJECTS_CLICK = 'org.nav.projects.click';
export const ORG_NAV_PULLREQUESTS_CLICK = 'org.nav.pullrequests.click';
export const ORG_NAV_OWNER_SETTINGS_CLICK = 'org.nav.owner_settings.click';
export const ORG_NAV_COMMENT_HISTORY_CLICK = 'org.nav.comment_history.click';

// project sidebar navigation
export const PROJECT_NAV_ABOUT_CLICK = 'project.nav.about.click';
export const PROJECT_NAV_DASHBOARD_CLICK = 'project.nav.dashboard.click';
export const PROJECT_NAV_NOTES_CLICK = 'project.nav.notes.click';
export const PROJECT_NAV_PULLREQUESTS_CLICK = 'project.nav.pullrequests.click';
export const PROJECT_NAV_AUTOMATION_CONFIG_CLICK =
  'project.nav.automation_config.click';
export const PROJECT_NAV_SETTINGS_CLICK = 'project.nav.settings.click';

// billing settings
export const BILLING_PLAN_TAB_CLICK = 'org.settings.billing.tab.plan.click';
export const BILLING_INFO_TAB_CLICK =
  'org.settings.billing.tab.billing_info.click';
export const BILLING_INVOICES_TAB_CLICK =
  'org.settings.billing.tab.invoices.click';

// billing info tab
export const BILLING_ADD_NEW_CARD_CLICK =
  'org.settings.billing.add_new_card.click';
export const BILLING_INFO_UPDATE_SUBMIT =
  'org.settings.billing.info_update.submit';
export const BILLING_INFO_UPDATE_SUCCESS =
  'org.settings.billing.info_update.success';
export const BILLING_INFO_UPDATE_FAILURE =
  'org.settings.billing.info_update.failure';
export const BILLING_INVOICE_CONTACT_UPDATE_CLICK =
  'org.settings.billing.invoice_contact_update.click';
export const BILLING_INFO_SCHEDULE_MEETING_CLICK =
  'org.settings.billing.schedule_meeting.click';
export const UPDATE_BILLING_INFO_SCHEDULE_MEETING_CLICK =
  'org.settings.billing.info_update.schedule_meeting.click';

// plan tab
export const BILLING_PLAN_CLICK_CANCEL =
  'org.settings.billing.plan.cancel.click';
export const BILLING_PLAN_CLICK_RENEW = 'org.settings.billing.plan.renew.click';
export const BILLING_PLAN_CODE_REVIEW_ENABLE_CLICK =
  'org.settings.billing.plan.code_review.enable.click';

// invoices tab
export const BILLING_INVOICE_DOWNLOAD_CLICK =
  'org.settings.billing.invoice.download.click';

// membership
export const MEMBERSHIP_CONTRIBUTORS_TAB_CLICK =
  'org.settings.membership.contributors.tab.click';
export const MEMBERSHIP_MEMBERS_TAB_CLICK =
  'org.settings.membership.members.tab.click';
export const MEMBERSHIP_INVITE_TAB_CLICK =
  'org.settings.membership.invite.tab.click';

// invite members tab
export const MEMBERSHIP_MEMBER_CONNECT =
  'org.settings.membership.members.connect.click';

// owner settings
export const OWNER_TOGGLE_CORPUS_NOTES_LOCK_CLICK =
  'org.settings.owner.notes_lock.toggle.click';
export const OWNER_TOGGLE_FULL_REPO_SEARCH_CLICK =
  'org.settings.owner.full_repo_search.toggle.click';

// onprem proxy settings
export const ONPREM_GENERATE_TOKEN_CLICK =
  'org.settings.onprem.generate_token.click';
export const ONPREM_REVOKE_TOKEN_CLICK =
  'org.settings.onprem.revoke_token.click';
export const ONPREM_ENABLE_UPGRADE_CLICK =
  'org.settings.onprem.enable_upgrade.click';
export const ONPREM_DISABLE_UPGRADE_CLICK =
  'org.settings.onprem.disable_upgrade.click';
export const ONPREM_MANUAL_UPGRADE_CLICK =
  'org.settings.onprem.manual_upgrade.click';
export const ONPREM_TEST_CONNECTION_CLICK =
  'org.settings.onprem.test_connection.click';

// projects
export const PROJECT_ROW_CLICK = 'org.projects.row.click';
export const PROJECT_ROW_SETTINGS_CLICK = 'org.projects.row.settings.click';
export const ADD_PROJECTS_CLICK = 'add_projects.click';
export const ONBOARDING_CODE_REVIEW_PROJECT_SELECT_CLICK =
  'onboarding.code_review.project_select.click';

// pull requests page (org and project level)
export const REVIEW_CANCEL_CLICK = 'review.cancel.click';
export const REVIEWS_REQUEST_CLICK = 'review.request.click';
export const REVIEW_REQUEST_PAYMENT_NEEDED_SHOW =
  'review_request.payment_needed.show';
export const REVIEW_REQUEST_POSTING_USER_NEEDED_SHOW =
  'review_request.posting_user_needed.show';
export const ORG_PULLREQUESTS_OPEN_ROW_CLICK =
  'org.pullrequests.open_table_row.click';
export const ORG_PULLREQUESTS_CLOSED_ROW_CLICK =
  'org.pullrequests.closed_table_row.click';
export const PROJECT_PULLREQUESTS_OPEN_ROW_CLICK =
  'project.pullrequests.open_table_row.click';
export const PROJECT_PULLREQUESTS_CLOSED_ROW_CLICK =
  'project.pullrequests.closed_table_row.click';
export const ORG_PULLREQUESTS_FILTER_AUTHOR_CLICK =
  'org.pullrequests.filter_author.click';
export const PROJECT_PULLREQUESTS_FILTER_AUTHOR_CLICK =
  'project.pullrequests.filter_author.click';
export const PROJECT_TODOS_FILTER_AUTHOR_CLICK =
  'project.todos.filter_author.click';

// static config
export const PROJECT_AUTOMATION_CONFIG_ENABLE =
  'project.automation_config.enable';
export const PROJECT_AUTOMATION_CONFIG_SCROLL =
  'project.automation_config.scroll';

// project settings
export const BULK_AUTO_REVIEW_ENABLE_CLICK =
  'org.settings.auto_review.enable.click';
export const BULK_AUTO_REVIEW_DISABLE_CLICK =
  'org.settings.auto_review.disable.click';
export const AUTO_REVIEW_DISABLE_CLICK =
  'project.settings.auto_review.disable.click';
export const AUTO_REVIEW_ENABLE_CLICK =
  'project.settings.auto_review.enable.click';
export const AUTO_REVIEW_UPDATE_SUCCESS =
  'project.settings.auto_review.update.success';
export const AUTO_REVIEW_UPDATE_FAILURE =
  'project.settings.auto_review.update.failure';
export const MANUAL_REVIEW_DISABLE_CLICK =
  'project.settings.manual_review.disable.click';
export const MANUAL_REVIEW_ENABLE_CLICK =
  'project.settings.manual_review.enable.click';
export const PROJECT_MARK_ONBOARDED_CLICK = 'project.settings.onboarded.click';
export const PROJECT_SETTINGS_DROPDOWN_CLICK =
  'project.settings.dropdown.click';
export const PROJECT_SETTINGS_COMMENT_POSTING_ENABLE_CLICK =
  'project.settings.comment_posting_enable.click';
export const PROJECT_SETTINGS_COMMENT_POSTING_DISABLE_CLICK =
  'project.settings.comment_posting_disable.click';
export const PROJECT_SETTINGS_AUTOMATION_ENABLE_CLICK =
  'project.settings.automation_enable.click';
export const PROJECT_SETTINGS_AUTOMATION_DISABLE_CLICK =
  'project.settings.automation_disable.click';
export const PROJECT_SETTINGS_SCHEDULE_MEETING_CLICK =
  'project.settings.schedule_meeting.click';
export const PROJECT_SETTINGS_APPROVALS_ENABLE_CLICK =
  'project.settings.approvals_enable.click';
export const PROJECT_SETTINGS_APPROVALS_DISABLE_CLICK =
  'project.settings.approvals_disable.click';
export const REVIEWER_APPROVALS_UPDATE_SUCCESS =
  'project.settings.reviewer_approvals.update.success';
export const REVIEWER_APPROVALS_UPDATE_FAILURE =
  'project.settings.reviewer_approvals.update.failure';

// review page
export const PROJECT_CODE_CHANGES_TAB_CLICK =
  'project.review.tab.code_changes.click';
export const PROJECT_TIMELINE_TAB_CLICK = 'project.review.tab.timeline.click';
export const PROJECT_STATIC_ANALYSIS_TAB_CLICK =
  'project.review.tab.static_analysis.click';

// code changes tab
export const PROJECT_CODE_CHANGES_SPLIT_VIEW =
  'project.code_changes.split_view.click';
export const PROJECT_CODE_CHANGES_UNIFIED_VIEW =
  'project.code_changes.unified_view.click';
export const PROJECT_CODE_CHANGES_SCROLL = 'project.review.code_changes.scroll';

// static analysis tab
export const PROJECT_STATIC_ANALYSIS_SCROLL =
  'project.review.static_analysis.scroll';
export const STATIC_ANALYSIS_SNOOZE_CLICK =
  'project.static_analysis.snooze.click';
export const STATIC_ANALYSIS_SNOOZE_UNDO_CLICK =
  'project.static_analysis.snooze_undo.click';
export const STATIC_ANALYSIS_DISABLE_RULE_MODAL_CLICK =
  'project.static_analysis.disable_modal.click';
export const STATIC_ANALYSIS_DISABLE_RULE_CLICK =
  'project.static_analysis.disable.click';
export const STATIC_ANALYSIS_DISABLE_RULE_UNDO_CLICK =
  'project.static_analysis.disable_undo.click';
export const STATIC_ANALYSIS_RESTART_JOB_CLICK =
  'project.static_analysis.restart_job.click';
export const STATIC_ANALYSIS_GITHUB_REFERRAL =
  'project.static_analysis.github_referral';
export const STATIC_ANALYSIS_GITLAB_REFERRAL =
  'project.static_analysis.gitlab_referral';
export const STATIC_ANALYSIS_BITBUCKET_REFERRAL =
  'project.static_analysis.bitbucket.referral';

// project dashboard
export const DASHBOARD_PR_CLICK = 'project.dashboard.pr.click';
export const PROJECT_DASHBOARD_SCROLL = 'project.dashboard.scroll';

// review notes (about)
export const REVIEWER_NOTES_SAVE_CLICK = 'project.notes.save.click';

// user settings
export const USER_SETTINGS_CLICK = 'user_settings.click';
export const USER_SETTINGS_INTEGRATIONS_CLICK =
  'user_settings.tab.integrations.click';
export const USER_SETTINGS_PROFILE_CLICK = 'user_settings.tab.profile.click';
export const USER_SETTINGS_SECURITY_CLICK = 'user_settings.tab.security.click';

// user profile
export const USER_PHOTO_EDIT_CLICK = 'user_settings.user_photo.edit.click';
export const USER_PHOTO_UPLOAD_FAILURE =
  'user_settings.user_photo.upload.failure';
export const USER_PHOTO_UPLOAD_SUCCESS =
  'user_settings.user_photo.upload.success';
export const USER_PROFILE_SAVE_CLICK =
  'user_settings.user_settings.profile.save.click';

// security
export const SETTINGS_2FA_DISABLE_CLICK =
  'user_settings.security.2fa_disable.click';
export const SETTINGS_2FA_ENABLE_CLICK =
  'user_settings.security.2fa_enable.click';
export const SETTINGS_2FA_ENABLE_FAILURE =
  'user_settings.security.2fa_enable.failure';
export const SETTINGS_2FA_ENABLE_SUCCESS =
  'user_settings.security.2fa_enable.success';
export const SETTINGS_2FA_VERIFY_SUBMIT =
  'user_settings.security.2fa_verify.submit';
export const SETTINGS_2FA_VERIFY_FAILURE =
  'user_settings.security.2fa_verify.failure';
export const SETTINGS_2FA_VERIFY_SUCCESS =
  'user_settings.security.2fa_verify.success';
export const SETTINGS_UPDATE_PASSWORD_CLICK =
  'user_settings.security.update_password.click';
export const SETTINGS_UPDATE_PASSWORD_FAILURE =
  'user_settings.security.update_password.failure';
export const SETTINGS_UPDATE_PASSWORD_SUCCESS =
  'user_settings.security.update_password.success';

// integrations
export const SETTINGS_OAUTH_CLICK = 'user_settings.integration.oauth.click';
export const SETTINGS_INSTALL_CLICK = 'user_settings.integration.install.click';

// when impersonating a user we don't want to fire any analytic events
let disabled = false;
export const disableEvents = (status) => {
  disabled = status;
};

// functions
export const logEvent = async (type, extra = {}) => {
  if (!disabled) {
    await Api.post('action/event', {
      type,
      extra,
    });
    if (window.analytics) {
      window.analytics.track(type, extra);
    }
  }
};

const handlers = {};
export function logScrollEvent(name, interval = 10000) {
  if (!handlers[name]) {
    handlers[name] = debounce(() => logEvent(name), interval, {
      leading: true,
      trailing: false,
    });
  }
  handlers[name]();
}

/**
 * Log an event at most once per `interval` ms, given an event name and an optional payload to send with the event
 *
 * @param {string} name
 * @param {Object|null} extra
 * @param {number} interval
 */
export function logThrottledEvent(
  name,
  extra = null,
  interval = THROTTLE_INTERVAL
) {
  if (!handlers[name]) {
    handlers[name] = throttle(() => logEvent(name, extra), interval, {
      leading: true,
      trailing: false,
    });
  }
  handlers[name]();
}

export const getLogTitle = (title) => {
  return title === '' ? 'web-client' : `web-client__${title}`;
};

export const logToSentry = (error, title = '') => {
  const finalTitle = getLogTitle(title);

  StackTrace.fromError(error)
    .then((stack) => logError(finalTitle, null, stack.join('\n')))
    .catch((err) => console.log(err));
};

export const logError = (message, extra = null, stack = '') => {
  if (!disabled) {
    Api.post('action/error', {
      message,
      stack,
      extra,
    });
  }
};

export const initialize = (
  userUUID,
  email,
  name,
  intercomHash,
  isReviewer,
  isDeveloper,
  isBenchmarksSignup
) => {
  if (!window.analytics || disabled) {
    return;
  }
  window.analytics.identify(
    userUUID,
    {
      email,
      name,
      is_reviewer: isReviewer,
      is_developer: isDeveloper,
      is_benchmarks_signup: isBenchmarksSignup,
    },
    {
      Intercom: {
        user_hash: intercomHash,
      },
    }
  );
};

export const shutdown = () => {
  if (!window.analytics || disabled) {
    return;
  }
  window.analytics.reset();
  window.Intercom?.('shutdown');
};

export const page = () => {
  if (!window.analytics || disabled) {
    return;
  }
  window.analytics.page();
};
